.eds-page-header-host {
  container-name: eds-page-header;
  container-type: inline-size;
}

.eds-page-header {
  align-items: center;
  display: grid;
  gap: var(--eds--spacing-24);
  grid-template-columns: minmax(0, 1fr) auto;
  padding-block: var(--eds--padding-16);
}

/* Below this width there's no room for the actions beside the title/subtitle
   column, so stack them.*/
@container eds-page-header (max-width: 650px) {
  .eds-page-header {
    grid-template-columns: minmax(0, 1fr);
  }
}

.eds-page-header--title-block,
.eds-page-header--title {
  min-width: 0;
}

/* The truncated title's trigger grows to fill a flex row, which would park the
   badge and title slot at the far end. Keep the title content-sized so those
   sit against the text, and let it shrink (and ellipsize) only when the row
   runs out of room. */
.eds-page-header--title {
  flex: 0 1 auto;
  overflow: hidden;
}

.eds-page-header--title-adornment {
  flex: none;
}
